export default "__VITE_ASSET__gDgxyoYY__"